import { CompanyFragment, LoanStatus } from '@willow/graphql-iso/src/portal';
import { LosId } from '@willow/types-iso';

import { ContactCTA } from '../../contact-cta/ContactCTA';
import { PortalNavLinks } from '../nav-items/NavItems';

import './Nav.scss';

interface Props {
  selectedLoanId?: LosId;
  company?: CompanyFragment;
  loanStatus?: LoanStatus;
  hasActiveLoan: boolean;
}

export const PortalNav = ({ selectedLoanId, company, hasActiveLoan, loanStatus }: Props) => {
  return (
    <nav className="portal-nav">
      <PortalNavLinks
        losId={selectedLoanId}
        hasActiveLoan={hasActiveLoan}
        companyId={company?.id}
        loanStatus={loanStatus}
      />

      {company && hasActiveLoan && <ContactCTA company={company} />}
    </nav>
  );
};
